<template>
  <div class="manage-user-card">
    <div class="manage-user-card__delete"
         @click="$emit('onDeleteUserClick', user.webAccountId)">
      <b-button variant="danger"
                aria-label="Delete user"
                class="btn btn-sm"
                :disabled="!usersEditable">
        <span class="visually-hidden">
          Delete user
        </span>
        <font-awesome-icon :icon="['far', 'trash-alt']">
        </font-awesome-icon>
      </b-button>
    </div>

    <div class="manage-user-card__name">
      {{ user.name }}
    </div>
    <div class="manage-user-card__email">
      {{ user.email }}
    </div>

    <div class="row no-padding">
      <div class="col-xs-12">
        <b-form-checkbox
          v-model="user.organisationAdministrator"
          class="manage-user-card__organisationAdministrator"
          :disabled="!usersEditable"
          @change="
            $emit(
              'onOrganisationAdministratorClick',
              $event,
              user.webAccountId,
              'organisationAdministrator'
            )
          ">
          <div :id="'organisationAdministratorCard_' + user.webAccountId">
            School account administrator
          </div>
        </b-form-checkbox>

        <b-tooltip
          :target="'organisationAdministratorCard_' + user.webAccountId"
          triggers="hover"
          variant="light">
          <p>Can order all types of product and can manage school user accounts</p>
        </b-tooltip>

        <b-form-checkbox
          v-model="user.canOrderTraining"
          class="manage-user-card__canOrderTraining"
          :disabled="!usersEditable"
          @change="$emit('onCanOrderTrainingClick', $event, user.webAccountId, 'canOrderTraining')">
          Can order training/conferences
        </b-form-checkbox>

        <b-form-checkbox
          v-model="user.canOrderConsultancy"
          class="manage-user-card__canOrderConsultancy"
          :disabled="!usersEditable"
          @change="
            $emit('onCanOrderConsultancyClick', $event, user.webAccountId, 'canOrderConsultancy')
          ">
          Can order consultancy/subscriptions
        </b-form-checkbox>

        <b-form-checkbox
          v-model="user.suspendedAccount"
          class="manage-user-card__suspendedAccount"
          :disabled="!usersEditable"
          @change="$emit('onSuspendedAccountClick', $event, user.webAccountId, 'suspendedAccount')">
          <div :id="'userAccountSuspendedCard_' + user.webAccountId">
            Suspend account
          </div>
        </b-form-checkbox>

        <b-tooltip
          v-if="user.dateAccountSuspended !== null"
          :target="'userAccountSuspendedCard_' + user.webAccountId"
          triggers="hover"
          variant="light">
          <p>Account suspended on {{ user.dateAccountSuspended }}</p>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManageUserCard",
  components: {},
  props: {
    user: {
      type: Object,
      default: null
    },
    usersEditable: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.manage-user-card {
  position: relative;
  border: 2px solid #b2d6d9;
  background-color: #fff;
  padding: 10px;
  margin: 10px 0;

  &__delete {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;

    &:hover {
      color: #777;
      cursor: pointer;
    }
  }

  &__name {
    font-size: 1.25rem;
    font-weight: 600;
    padding-right: 20px;
  }

  &__email {
    font-size: 0.8rem;
    color: #666;
  }

  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }

  &__organisationAdministrator {
    padding-top: 15px;
    padding-bottom: 5px;
  }

  &__canOrderTraining,
  &__canOrderConsultancy,
  &__suspendedAccount {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
</style>
